<template>
  <v-card>
    <v-form
        ref="radar-form"
    >
      <v-card-title>
        {{ editableRadar.name }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-switch
                v-model="editableRadar.is_private"
                true-value="1"
                :label="$t('form.general.private.label')"
                color="error"
            ></v-switch>
          </v-col>

          <v-col cols="6">
            <v-select
                v-model="editableRadar.country"
                :label="$t('form.country.label')"
                :items="countries"
                item-text="name"
                item-value="iso"
                required
                :error-messages="countryErrors"
                @blur="$v.editableRadar.country.$touch()"
            ></v-select>
          </v-col>

          <v-col cols="12">
            <v-text-field
                v-model="editableRadar.name"
                :label="$t('form.radar.name.label')"
                :error-messages="nameErrors"
                :counter="30"
                required
                @blur="$v.editableRadar.name.$touch()"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-textarea
                v-model="editableRadar.description"
                :label="$t('form.radar.description.label')"
                :error-messages="descriptionErrors"
                required
                @blur="$v.editableRadar.description.$touch()"
            ></v-textarea>
          </v-col>

          <v-col cols="6">
            <v-text-field
                v-model="editableRadar.quadrant_0"
                :label="$t('form.radar.quadrant.label') + ' 1'"
                :error-messages="quadrant0Errors"
                :counter="22"
                required
                @blur="$v.editableRadar.quadrant_0.$touch()"
            ></v-text-field>
            <v-text-field
                v-model="editableRadar.quadrant_3"
                :label="$t('form.radar.quadrant.label') + ' 4'"
                :error-messages="quadrant2Errors"
                :counter="22"
                required
                @blur="$v.editableRadar.quadrant_2.$touch()"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
                v-model="editableRadar.quadrant_1"
                :label="$t('form.radar.quadrant.label') + ' 2'"
                :error-messages="quadrant1Errors"
                :counter="22"
                required
                @blur="$v.editableRadar.quadrant_1.$touch()"
            ></v-text-field>
            <v-text-field
                v-model="editableRadar.quadrant_2"
                :label="$t('form.radar.quadrant.label') + ' 3'"
                :error-messages="quadrant3Errors"
                :counter="22"
                required
                @blur="$v.editableRadar.quadrant_3.$touch()"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
                v-model="editableRadar.sector_0"
                :label="$t('form.radar.sector.label') + ' 1'"
                :error-messages="sector0Errors"
                :counter="22"
                required
                @blur="$v.editableRadar.sector_0.$touch()"
            ></v-text-field>
            <v-text-field
                v-model="editableRadar.sector_2"
                :label="$t('form.radar.sector.label') + ' 3'"
                :error-messages="sector2Errors"
                :counter="22"
                required
                @blur="$v.editableRadar.sector_2.$touch()"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
                v-model="editableRadar.sector_1"
                :label="$t('form.radar.sector.label') + ' 2'"
                :error-messages="sector1Errors"
                :counter="22"
                required
                @blur="$v.editableRadar.sector_1.$touch()"
            ></v-text-field>

            <v-text-field
                v-model="editableRadar.sector_3"
                :label="$t('form.radar.sector.label') + ' 4'"
                :error-messages="sector3Errors"
                :counter="22"
                required
                @blur="$v.editableRadar.sector_3.$touch()"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
            text
            @click="close"
        >
          {{ $t('controls.cancel') }}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn icon right color="error" v-if="!isNew" @click="openDeleteDialog">
          <v-icon>mdi-delete</v-icon>
        </v-btn>

        <v-btn
            dark
            @click="save"
        >
                   <span v-if="isNew">
                        {{ $t('controls.create') }}
                    </span>
          <span v-else>
                        {{ $t('controls.save') }}
                    </span>
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { minLength, maxLength, required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  name: 'RadarForm',
  components: {},
  mixins: [validationMixin],

  validations: {
    editableRadar: {
      country: {
        required
      },
      name: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(22)
      },
      description: {
        required,
        minLength: minLength(10),
      },
      quadrant_0: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(22)
      },
      quadrant_1: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(22)
      },
      quadrant_2: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(22)
      },
      quadrant_3: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(22)
      },
      sector_0: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(22)
      },
      sector_1: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(22)
      },
      sector_2: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(22)
      },
      sector_3: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(22)
      },
    }
  },

  provide () {
    return {
      $v: this.$v
    }
  },

  props: {
    cancel: {
      type: Boolean,
      default: false
    },
    radar: {
      type: Object,
      default () {
        return {}
      },
    }
  },

  data () {
    return {
      radarBlueprint: {
        country: 'CH',
        name: '',
        description: '',
        quadrant_0: this.$t('radar.defaults.quadrant_0'),
        quadrant_1: this.$t('radar.defaults.quadrant_1'),
        quadrant_2: this.$t('radar.defaults.quadrant_2'),
        quadrant_3: this.$t('radar.defaults.quadrant_3'),
        sector_0: this.$t('radar.defaults.sector_0'),
        sector_1: this.$t('radar.defaults.sector_1'),
        sector_2: this.$t('radar.defaults.sector_2'),
        sector_3: this.$t('radar.defaults.sector_3'),
      },
      editableRadar: {}
    }
  },

  computed: {
    ...mapGetters({
      countries: 'countries/getCountries'
    }),

    isNew: function () {
      return this.editableRadar.id === undefined
    },

    countryErrors () {
      const errors = []
      if (!this.$v.editableRadar.country.$dirty) return errors
      !this.$v.editableRadar.country.required && errors.push(this.$t('form.country.required'))
      return errors
    },

    nameErrors () {
      const errors = []
      if (!this.$v.editableRadar.name.$dirty) return errors
      !this.$v.editableRadar.name.required && errors.push(this.$t('form.radar.name.required'))
      !this.$v.editableRadar.name.minLength && errors.push(this.$t('form.radar.name.min-length'))
      !this.$v.editableRadar.name.maxLength && errors.push(this.$t('form.radar.name.max-length'))
      return errors
    },

    descriptionErrors () {
      const errors = []
      if (!this.$v.editableRadar.description.$dirty) return errors
      !this.$v.editableRadar.description.required && errors.push(this.$t('form.radar.description.required'))
      !this.$v.editableRadar.description.minLength && errors.push(this.$t('form.radar.description.min-length'))
      return errors
    },

    quadrant0Errors () {
      const errors = []
      if (!this.$v.editableRadar['quadrant_0'].$dirty) return errors
      !this.$v.editableRadar['quadrant_0'].required && errors.push(this.$t('form.radar.quadrant.required'))
      !this.$v.editableRadar['quadrant_0'].minLength && errors.push(this.$t('form.radar.quadrant.min-length'))
      !this.$v.editableRadar['quadrant_0'].maxLength && errors.push(this.$t('form.radar.quadrant.max-length'))
      return errors
    },

    quadrant1Errors () {
      const errors = []
      if (!this.$v.editableRadar['quadrant_1'].$dirty) return errors
      !this.$v.editableRadar['quadrant_1'].required && errors.push(this.$t('form.radar.quadrant.required'))
      !this.$v.editableRadar['quadrant_1'].minLength && errors.push(this.$t('form.radar.quadrant.min-length'))
      !this.$v.editableRadar['quadrant_1'].maxLength && errors.push(this.$t('form.radar.quadrant.max-length'))
      return errors
    },

    quadrant2Errors () {
      const errors = []
      if (!this.$v.editableRadar['quadrant_2'].$dirty) return errors
      !this.$v.editableRadar['quadrant_2'].required && errors.push(this.$t('form.radar.quadrant.required'))
      !this.$v.editableRadar['quadrant_2'].minLength && errors.push(this.$t('form.radar.quadrant.min-length'))
      !this.$v.editableRadar['quadrant_2'].maxLength && errors.push(this.$t('form.radar.quadrant.max-length'))
      return errors
    },

    quadrant3Errors () {
      const errors = []
      if (!this.$v.editableRadar['quadrant_3'].$dirty) return errors
      !this.$v.editableRadar['quadrant_3'].required && errors.push(this.$t('form.radar.quadrant.required'))
      !this.$v.editableRadar['quadrant_3'].minLength && errors.push(this.$t('form.radar.quadrant.min-length'))
      !this.$v.editableRadar['quadrant_3'].maxLength && errors.push(this.$t('form.radar.quadrant.max-length'))
      return errors
    },

    sector0Errors () {
      const errors = []
      if (!this.$v.editableRadar['sector_0'].$dirty) return errors
      !this.$v.editableRadar['sector_0'].required && errors.push(this.$t('form.radar.sector.required'))
      !this.$v.editableRadar['sector_0'].minLength && errors.push(this.$t('form.radar.sector.min-length'))
      !this.$v.editableRadar['sector_0'].maxLength && errors.push(this.$t('form.radar.sector.max-length'))
      return errors
    },

    sector1Errors () {
      const errors = []
      if (!this.$v.editableRadar['sector_1'].$dirty) return errors
      !this.$v.editableRadar['sector_1'].required && errors.push(this.$t('form.radar.sector.required'))
      !this.$v.editableRadar['sector_1'].minLength && errors.push(this.$t('form.radar.sector.min-length'))
      !this.$v.editableRadar['sector_1'].maxLength && errors.push(this.$t('form.radar.sector.max-length'))
      return errors
    },

    sector2Errors () {
      const errors = []
      if (!this.$v.editableRadar['sector_2'].$dirty) return errors
      !this.$v.editableRadar['sector_2'].required && errors.push(this.$t('form.radar.sector.required'))
      !this.$v.editableRadar['sector_2'].minLength && errors.push(this.$t('form.radar.sector.min-length'))
      !this.$v.editableRadar['sector_2'].maxLength && errors.push(this.$t('form.radar.sector.max-length'))
      return errors
    },

    sector3Errors () {
      const errors = []
      if (!this.$v.editableRadar['sector_3'].$dirty) return errors
      !this.$v.editableRadar['sector_3'].required && errors.push(this.$t('form.radar.sector.required'))
      !this.$v.editableRadar['sector_3'].minLength && errors.push(this.$t('form.radar.sector.min-length'))
      !this.$v.editableRadar['sector_3'].maxLength && errors.push(this.$t('form.radar.sector.max-length'))
      return errors
    },
  },

  mounted () {
    this.editableRadar = Object.assign(this.radarBlueprint, this.radar)
  },

  methods: {

    save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let dispatchMethod = this.isNew ? 'radars/createRadar' : 'radars/updateRadar'

        this.$store.dispatch(dispatchMethod, this.editableRadar).then((response) => {
          if (this.isNew) {
            // reset form
            this.resetForm()

            // set as new radar
            this.$store.commit('radars/setCurrentRadarId', response.data.radar.id)

            this.$store.commit('notification/newNotification', {
              text: this.$t('form.radar.created')
            })
          } else {
            this.$store.commit('notification/newNotification', {
              text: this.$t('form.radar.updated')
            })
          }

          this.$emit('radarIsProcessed')
        })
      }
    },

    close () {
      this.$emit('radarIsCanceled')
      this.resetForm()
    },

    resetForm () {
      this.country = this.radar.country
      this.editableRadar = Object.assign(this.radarBlueprint, this.radar)
      this.$v.$reset()
    },

    openDeleteDialog () {
      const deletedText = this.$t('form.radar.removed')

      this.$store.commit('prompt/newPrompt', {
        title: this.$t('dialog.delete.title') + ' ' + this.radar.name,
        text: this.$t('dialog.delete.radar.text'),
        execCallback: function () {
          this.$store.dispatch('radars/removeRadar', this.radar.id)
              .then(() => {
                // close form
                this.$emit('radarIsProcessed')
                this.resetForm()

                this.$router.push({ name: 'dashboard' }).catch(() => {})

                // trigger notification
                this.$store.commit('notification/newNotification', {
                  text: deletedText
                })
              })
        }.bind(this)
      })
    },
  },

  watch: {
    radar () {
      this.editableRadar = Object.assign(this.radarBlueprint, this.radar)
    }
  }
}
</script>
